import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import RequestError from 'flarum/common/utils/RequestError';
import parseValidationError from '../utils/parseValidationError';

export default abstract class AbstractProcessingPage extends Page {
    errorPage: string | null = null;
    dirty: boolean = false;
    loading: boolean = false;
    savedAt: Date | null = null;
    validationErrors: any = {};

    pageLoadErrorHandler(error: any) {
        switch (error.status) {
            case 401:
            case 403:
                this.errorPage = 'denied';
                break;
            case 404:
            case 410:
                this.errorPage = 'notfound';
                break;
            default:
                throw error;
        }

        m.redraw();
    }

    onerror(error: any) {
        this.loading = false;

        let wasHandled = false;

        if (error.status === 422 && error.response.errors) {
            wasHandled = true;

            this.validationErrors = parseValidationError(error);
        } else {
            // This value is already reset explicitly when a request completes successfully
            // However if a 422 error is followed by another error, the page would continue showing that the validation failed
            // despite now facing a completely different error
            this.validationErrors = {};
        }

        m.redraw();

        if (!wasHandled) {
            // Re-implementation of Flarum's Application.requestErrorDefaultHandler
            if (error instanceof RequestError) {
                if (app.forum.attribute('debug') && error.xhr) {
                    const {method, url} = error.options;
                    const {status = ''} = error.xhr;

                    console.group(`${method} ${url} ${status}`);
                    console.error(error);
                    console.groupEnd();
                }

                if (error.alert) {
                    app.alerts.show(error.alert, error.alert.content);
                }
            } else {
                throw error;
            }
        }
    }
}
